import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  styled,
  CircularProgress,
  IconButton,
} from "@mui/material";
import {
  addCommentsAcqcommentupdate,
  addCommentsCallcomment,
  addCommentsOnlineLead,
} from "../../services/newdashboard";
import { useAppSelector } from "../../store/hook";
import { toast } from "react-toastify";
import { Cross } from "recharts";

type InfoModalProps = {
  open: boolean;
  onClose: () => void;
  data: Record<string, any> | null;
  onAddComment?: (comment: string) => void;
  clinicData?: string;
  refetchApi?: any;
  api?: string;
};

const CommentModal: React.FC<InfoModalProps> = ({
  open,
  onClose,
  data,
  onAddComment,
  clinicData,
  refetchApi,
  api,
}) => {
  if (!data) return null;
  const clinics = useAppSelector((state) => state.user.user.clinics);
  const clinicDatax = clinics?.find(
    (item: any) => item.uniqueId === clinicData
  );
  const [newComment, setNewComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let comments: Array<Record<string, any>> = [];

  if (data?.comment) {
    try {
      const parsed =
        typeof data?.comment === "string"
          ? JSON.parse(data?.comment)
          : data.comment;

      if (Array.isArray(parsed)) {
        comments = parsed;
      } else if (typeof parsed === "object") {
        comments = [parsed]; // 👈 wrap single object
      }
    } catch (err) {
      console.error("Failed to parse comment JSON:", err);
      comments = [];
    }
  }

  const handleAddComment = async () => {
    setIsLoading(true);

    const payload = {
      comment: [
        ...comments,
        {
          type: "Xcare",
          comment: newComment,
          commentBy: `${clinicDatax?.name}`,
        },
      ],
    };

    try {
      const response = await addCommentsOnlineLead(
        payload,
        clinicData ?? "",
        data.id
      );

      if (response?.status?.msg === "Success") {
        toast.success("Comment added successfully");
        refetchApi?.(); // refresh list
        setNewComment("");
        onClose();
      } else {
        toast.error("Failed to add comment");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }

    setIsLoading(false);
  };

  const handleAddComment2 = async () => {
    setIsLoading(true);

    const payload = {
      comment: [
        ...comments,
        {
          type: "Xcare",
          comment: newComment,
          commentBy: `${clinicDatax?.name}`,
        },
      ],
    };

    try {
      const response = await addCommentsCallcomment(
        payload,
        clinicData ?? "",
        data.id
      );

      if (response?.status?.msg === "Success") {
        toast.success("Comment added successfully");
        refetchApi?.(); // refresh list
        setNewComment("");
        onClose();
      } else {
        toast.error("Failed to add comment");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }

    setIsLoading(false);
  };

  console.log(data, "asdfghjytrew");

  const handleAddComment3 = async () => {
    setIsLoading(true);

    const payload = {
      acquType: "call",
      comment: [
        ...comments,
        {
          type: "Xcare",
          comment: newComment,
          commentBy: `${clinicDatax?.name}`,
        },
      ],
    };

    try {
      const response = await addCommentsAcqcommentupdate(
        payload,
        clinicData ?? "",
        data.id
      );

      if (response?.status?.msg === "Success") {
        toast.success("Comment added successfully");
        refetchApi?.(); // refresh list
        setNewComment("");
        onClose();
      } else {
        toast.error("Failed to add comment");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }

    setIsLoading(false);
  };

  const renderChatBubble = (item: any, index: number) => {
    const isXcare = item?.type === "Xcare";

    return (
      <Box
        key={index}
        sx={{
          display: "flex",
          justifyContent: isXcare ? "flex-end" : "flex-start",
          mb: 1.5,
        }}
      >
        <Box
          sx={{
            maxWidth: "75%",
            backgroundColor: isXcare ? "#c8f1ff" : "#f2f4f5",
            color: "#0E3843",
            padding: "10px 14px",
            borderRadius: "12px",
            borderBottomRightRadius: isXcare ? "4px" : "12px",
            borderBottomLeftRadius: isXcare ? "12px" : "4px",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          {/* Comment By */}
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              opacity: 0.7,
              display: "block",
              mb: 0.5,
            }}
          >
            {item?.type
              ? item.type.charAt(0).toUpperCase() +
                item.type.slice(1).toLowerCase()
              : "Xcare"}
          </Typography>

          {/* Comment text */}
          <Typography variant="body2">{item?.comment}</Typography>
        </Box>
      </Box>
    );
  };

  const LoadingSpinner = styled(CircularProgress)({
    color: "#4CC9C0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "26px !important",
    height: "26px !important",
  });

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setNewComment("");
      }}
      fullWidth
      maxWidth="xs"
      PaperProps={{ style: { borderRadius: 10 } }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#194e5b",
          color: "white",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          fontSize: 18,
          fontWeight: 600,
          py: 1.5,
          position: "relative",
        }}
      >
        Comment Details
        <IconButton
          onClick={onClose}
          sx={{
            pr: 2,
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
          }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: "18px" }}></i>
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        {comments?.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            No comment data available
          </Typography>
        ) : (
          <Box
            sx={{
              maxHeight: "350px",
              overflowY: "auto",
              paddingRight: "6px",
              pr: 1,
              mt: 1,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#ccc",
                borderRadius: "4px",
              },
            }}
          >
            {comments?.map((item, index) => renderChatBubble(item, index))}
          </Box>
        )}
        <Box mt={3}>
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Add a comment..."
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#f8f9f9",
              resize: "none",
              fontSize: "14px",
              minHeight: "60px",
              outline: "none",
            }}
          />

          <Button
            variant="contained"
            fullWidth
            disabled={isLoading}
            sx={{
              mt: 1.5,
              backgroundColor: "#194e5b",
              textTransform: "none",
              "&:hover": { backgroundColor: "#133b45" },
            }}
            onClick={() => {
              if (api === "newpatientcomment") {
                handleAddComment();
              } else if (api === "callcomment") {
                handleAddComment2();
              } else if (api === "acqcommentupdate") {
                handleAddComment3();
              }
            }}
          >
            {isLoading ? (
              <LoadingSpinner sx={{ position: "static", transform: "none" }} />
            ) : (
              "Add Comment"
            )}
          </Button>
        </Box>
      </DialogContent>

      {/* <DialogActions>
        <Button
          onClick={() => {
            onClose();
            setNewComment("");
          }}
          sx={{
            backgroundColor: "#c9eeeb",
            color: "#0E3843",
            textTransform: "none",
            borderRadius: 1,
            "&:hover": { backgroundColor: "#b6e3e0" },
          }}
        >
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default CommentModal;
